import styled from 'styled-components';

export const DotsStyled = styled.div`
    display: flex;
    align-items: center;
    gap: 11px;
    
    .selected-dot, .not-selected-dot {
        width: 5px;
        height: 5px;       
        border-radius: 50px;
    }

    .selected-dot {
        background: #6E74FF;
    }

    .not-selected-dot {
        background: #E9E9FD;
    }
`